import { render, staticRenderFns } from "./syncUser.vue?vue&type=template&id=9d40b54e&scoped=true"
import script from "./syncUser.vue?vue&type=script&lang=js"
export * from "./syncUser.vue?vue&type=script&lang=js"
import style0 from "./syncUser.vue?vue&type=style&index=0&id=9d40b54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d40b54e",
  null
  
)

export default component.exports